/** @jsx jsx */
import { useEffect } from 'react'
import { useMapboxContext } from '../useMapboxContext'

const Zoom = ({ zoom, coords, children }) => {
  if (coords !== undefined && (!Array.isArray(coords) || coords.length !== 2))
    throw new Error(
      'The coords prop must be an array with two values that are both numbers',
    )

  const { map } = useMapboxContext()

  useEffect(() => {
    // console.log(coords)
    map.current.easeTo({
      center: coords ?? undefined,
      zoom: zoom,
      // ...(!coords ? { center: coords } : {}),
    })
  }, [zoom])

  return children || null
}

export { Zoom }
